<template>
  <div class="radios">
    <div
        v-for="(radio, index) in radios"
        :key="index"
        class="radios-container">
      <label class="radio-wrapper" :for="radio.id">
        <input
            v-model="radioSelection"
            type="radio"
            :value="radio.value"
            :name="radio.name"
            :id="radio.id"
            @change="updateValue">
        <span :class="['radio', 'text-center', radio.id]"> {{radio.label}} </span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      currentValue: [String, Boolean],
      radios: Array,
    },

    name: 'Radios',

    data() {
      return {
        radioSelection: null,
      }
    },

    methods: {
      updateValue() {
        this.$emit('update', this.radioSelection)
      }
    },

    created() {
      this.radioSelection = this.currentValue
    },

    watch: {
      currentValue: function () {
        this.radioSelection = this.currentValue
      }
    }
  }
</script>
